import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c7e044a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = {
  key: 0,
  class: "com_sec1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "バナー登録・編集")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"55%"} })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" バナーエリア ")
], -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "form-control-title" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "table table-bordered" }
const _hoisted_19 = { class: "thead-light" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpdate" }, "編集", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_caption" }, "キャプション", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_bannerImg" }, "バナー画像", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_linkUrl" }, "リンクURL", -1))
const _hoisted_25 = {
  "data-name": "mSelection",
  style: {"text-align":"center"}
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { "data-name": "mBannerName" }
const _hoisted_30 = { "data-name": "mBannerCaption" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  "data-wrap": "",
  "data-name": "mLinkUrl"
}
const _hoisted_33 = {
  style: {"text-align":"center"},
  "data-name": "mHyoujiKIkan"
}
const _hoisted_34 = { class: "form-inline flex-container" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_NumericInput = _resolveComponent("NumericInput")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isDataFetched)
            ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                _hoisted_6,
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_11,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            id: "bannerArea",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBannerArea) = $event)),
                            disabled: !_ctx.isSearchMode
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerAreaList, (item) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: item.areaId,
                                value: item.areaId
                              }, _toDisplayString(item.areaName), 9, _hoisted_13))
                            }), 128))
                          ], 8, _hoisted_12), [
                            [_vModelSelect, _ctx.selectedBannerArea]
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("button", {
                            type: "button",
                            name: "btnSearch",
                            class: "btn btn-primary",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
                            disabled: !_ctx.isSearchMode
                          }, " 検索 ", 8, _hoisted_15)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            name: "btnClearH",
                            class: "btn btn-footer btn-primary",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                          }, " クリア ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", _hoisted_19, [
                      _createElementVNode("tr", null, [
                        _hoisted_20,
                        _hoisted_21,
                        _createElementVNode("th", {
                          class: _normalizeClass([
                  'col_bannerName',
                  'sortable',
                  _ctx.isDirectionASC('bannerName') ? 'asc' : 'desc',
                ]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSortItem('bannerName')))
                        }, " バナー名 ", 2),
                        _hoisted_22,
                        _hoisted_23,
                        _hoisted_24,
                        _createElementVNode("th", {
                          class: _normalizeClass([
                  'col_hyoujiKIkan',
                  'sortable',
                  _ctx.isDirectionASC('hyoujiKIkan') ? 'asc' : 'desc',
                ]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSortItem('hyoujiKIkan')))
                        }, " 表示期間 ", 2),
                        _createElementVNode("th", {
                          class: _normalizeClass([
                  'col_hyoujiJun',
                  'sortable',
                  _ctx.isDirectionASC('hyoujiJun') ? 'asc' : 'desc',
                ]),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSortItem('hyoujiJun')))
                        }, " 表示順 ", 2)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerDataList, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.bannerId,
                          class: _normalizeClass({ 'gray-background': _ctx.isDispEnd(item.dispDtTo) })
                        }, [
                          _createElementVNode("td", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              id: "mSelection",
                              "onUpdate:modelValue": ($event: any) => ((item.selection) = $event),
                              type: "checkbox",
                              class: "form-check-input"
                            }, null, 8, _hoisted_26), [
                              [_vModelCheckbox, item.selection]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createElementVNode("button", {
                              type: "button",
                              name: "mBtnUpdate",
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (_ctx.showUpdate(item.bannerId))
                            }, " 編集 ", 8, _hoisted_28)
                          ]),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(item.bannerName), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(item.bannerCaption), 1),
                          _createElementVNode("td", null, [
                            (item.bannerImgFileName)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "col_imgCell",
                                  src: 
                    '/WITH_AG_PORTAL/images/' +
                    item.bannerImgFileName +
                    '?v=' +
                    new Date().getTime()
                  
                                }, null, 8, _hoisted_31))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(item.bannerUrl), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.formatDispDate(item.dispDtFrom)) + " ～" + _toDisplayString(_ctx.formatDispDate(item.dispDtTo)), 1),
                          _createElementVNode("td", {
                            class: _normalizeClass({
                  'gray-background': _ctx.isDispEnd(item.dispDtTo),
                  unchanged: !_ctx.isDispEnd(item.dispDtTo),
                }),
                            "data-name": "mHyoujiJun"
                          }, [
                            _createVNode(_component_NumericInput, {
                              class: _normalizeClass({
                    'gray-background': _ctx.isDispEnd(item.dispDtTo),
                    unchanged: !_ctx.isDispEnd(item.dispDtTo),
                  }),
                              style: {"border":"powderblue solid 1px","text-align":"center","width":"100%"},
                              modelValue: item.dispOrder,
                              "onUpdate:modelValue": ($event: any) => ((item.dispOrder) = $event),
                              maxlength: "3"
                            }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])
                          ], 2)
                        ], 2))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnDelete",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args))),
                        disabled: _ctx.isSearchMode
                      }, " 削除 ", 8, _hoisted_36)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                      }, " 戻る "),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnClear",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                      }, " クリア "),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnUpdate",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args))),
                        disabled: _ctx.isSearchMode
                      }, " 更新 ", 8, _hoisted_38),
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnAdd",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args))),
                        disabled: _ctx.isSearchMode
                      }, " 新規登録 ", 8, _hoisted_39)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}